import React from "react";
import Layout from "../../../Components/Common/Layout";
import useNavHeading from "../../../Hooks/CommonHooks/useNavHeading ";
import DashLayout from "../../../Components/Admin/AdminDashLayout";
import MainSection from "./MainSection";
import ProtectedSection from "../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../config/permission";
import { useTranslation } from "react-i18next";

const StaffAttendance = () => {
  const { t } = useTranslation("admClass");
  useNavHeading(t("Staff Attendance"));
  return (
    <Layout title={t("Staff Attendance | Office Flow")}>
      <DashLayout
        children={
          <ProtectedSection
            requiredPermission={PERMISSIONS.VIEW_STAFF_ATTENDANCE}
          >
            <MainSection/>
          </ProtectedSection>
        }
        hideSearchbar={true}
      />
    </Layout>
  );
};

export default StaffAttendance;
